import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)
// import language_zh from './modules/language-zh'
// import language_en from './modules/language-en'

let requireComponent = require.context('./modules', true, /\.js$/)

let i18nMsgMap = {
    'en': {
    },
    'zh-cn': {
    }
};
requireComponent.keys().forEach(srcName => {
    // 获取组件配置
    let configJson = requireComponent(srcName);
    let [folderName, type] = srcName.match(/[^.js\/](\w|-)+/g);
    // let [folderName, type] = srcName.match(/(?<=\/).+(?=\/)|(en|zh-cn)/g);
    i18nMsgMap[type][folderName] = configJson
})
// module.exports = new VueI18n({
//     locale: 'en',
//     messages: i18nMsgMap,
//     silentTranslationWarn: true,
// })
export default new VueI18n({
    locale: 'en',
    messages: i18nMsgMap,
    silentTranslationWarn: true,
})



// WEBPACK FOOTER //
// ./src/i18n/index.js